
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { ExternalWallet, AuthQuery } from '~/mixins';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';
import {
  IWalletConnectionError,
  WalletConnectionErrorCode,
} from '~/store/web3_wallet/types';

@Component({ components: { TwoFactorAuthInputPrompt } })
export default class WalletConnectionErrorBanner extends Mixins(
  ExternalWallet,
  AuthQuery,
) {
  @State((w3w) => w3w.walletConnectionError, { namespace: 'web3Wallet' })
  walletConnectionError!: IWalletConnectionError;

  showDialog = true;
  walletConnectionErrorCode = WalletConnectionErrorCode;
  isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  dappPath = window.location.href.toString().replace(/(http[s]*:\/\/)/, '');

  get onConnectionPage() {
    return this.$route.name === 'connect-wallet';
  }

  get shortMessage() {
    return (
      this.walletConnectionError.shortMessage ||
      this.walletConnectionError.message
    );
  }

  get selectedProviderOption() {
    return this.providerOptions.find(
      (option) => option.label === this.connectedExternalWallet.walletProvider,
    );
  }

  get missingProviderLink() {
    if (this.selectedProviderOption) {
      return this.isMobile
        ? this.selectedProviderOption.missingProviderMobileLink(this.dappPath)
        : this.selectedProviderOption.missingProviderDesktopLink;
    }
    return '';
  }

  created() {
    if (
      this.walletConnectionError.code ===
      this.walletConnectionErrorCode.MISSING_PROVIDER
    ) {
      this.handleMissingProvider();
    }
  }

  capitalize(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  handleConnectClick() {
    this.connect(
      {
        label: this.connectedExternalWallet.walletProvider,
        connectToUser: false,
      },
      this.doAuthQuery,
    );
  }

  async handleMissingProvider() {
    if (this.selectedProviderOption) {
      if (this.isMobile && !window.location.href.includes('wb=true')) {
        // This might not work on all mobile devices for all web3 wallet apps. Some require the deep link to be initiated by a user action like a click. This link is provided in the install modal that gets shown
        window.open(
          this.selectedProviderOption.missingProviderMobileLink(this.dappPath),
          '_blank',
        );
      }
    }
  }
}
